import lazyLoading from './lazyLoading'
import DashboardLayout from '@layouts/Dashboard'
import FullLayout from '@layouts/Full'
import UserGuard from './guards/user-guard'

export default [
  {
    path: '/user/',
    component: DashboardLayout,
    beforeEnter: UserGuard,
    redirect: { name: 'user.cards.index' },
    children: [
      { name: 'user.cards.index', path: 'cards', component: lazyLoading('User/Card/Index'), beforeEnter: UserGuard },
      { name: 'user.profile', path: 'profile', component: lazyLoading('Common/Profile'), beforeEnter: UserGuard },
    ]
  },
  {
    path: '/user/',
    component: FullLayout,
    beforeEnter: UserGuard,
    redirect: { name: 'user.cards.index' },
    children: [
      { name: 'user.cards.create', path: 'websites/:id/card/create', component: lazyLoading('Agency/Pages/BizCards/Builder'), beforeEnter: UserGuard },
      { name: 'user.cards.edit', path: 'websites/:id/card/:cardId', component: lazyLoading('Agency/Pages/BizCards/Builder'), beforeEnter: UserGuard },
    ]
  }
]